import { createFilter } from '@spotify/confidence-core-react';

import { SurfaceFilterEditor } from '../SurfaceFilterEditor';
import { SurfaceFilterViewer } from '../SurfaceFilterViewer';

export const SURFACE_FILTER = createFilter<string[]>({
  id: 'surfaces',
  label: 'Surface',
  hotkey: 's',
  query: (value: string[]) => value.map(v => `surfaces:"${v}"`).join(' OR '),
  viewer: SurfaceFilterViewer,
  editor: SurfaceFilterEditor,
});
